import { useMemo } from 'react'
import { calculateIndicatorPosition } from '@/components/GestureViewer/calculateIndicatorPosition'
import type { SharedItemData, CirclePosition } from './types'

/**
 * Hook to calculate display position for shared item indicator
 * Converts image pixel coordinates to display coordinates accounting for zoom/resize
 */
export function useItemIndicatorPosition(
  params: SharedItemData,
  camera: any,
  displayWidth: number,
  displayHeight: number
): CirclePosition | null {
  return useMemo(() => {
    if (!camera || !displayWidth || !displayHeight) {
      console.log('[useItemIndicatorPosition] Missing:', { hasCamera: !!camera, displayWidth, displayHeight })
      return null
    }
    const { width: imageWidth, height: imageHeight } = camera.intrinsics

    console.log('[useItemIndicatorPosition] Calculating position:', {
      params,
      imageWidth,
      imageHeight,
      displayWidth,
      displayHeight
    })

    // Validate coordinates are within bounds
    if (params.x < 0 || params.x > imageWidth || params.y < 0 || params.y > imageHeight) {
      console.warn('[useItemIndicatorPosition] Coordinates out of bounds:', params, 'imageSize:', { imageWidth, imageHeight })
      return null
    }

    // Convert image pixels to display coordinates
    const [displayX, displayY] = calculateIndicatorPosition(
      [params.x, params.y],
      imageWidth,
      imageHeight,
      displayWidth,
      displayHeight
    )

    // Scale radius to display space
    const displayRadius = params.r * (displayWidth / imageWidth)

    console.log('[useItemIndicatorPosition] ✅ Position calculated:', { displayX, displayY, displayRadius })

    return {
      x: displayX,
      y: displayY,
      radius: displayRadius
    }
  }, [params, camera, displayWidth, displayHeight])
}
